import { useEffect, useRef, useMemo } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_CONFIG_UPDATE_REQUEST } from '../constants/events';

// preserves values during Redux state transitions and rerenders
const useStableValue = (value) => {
    const ref = useRef(value);
    if (value != null) {
        ref.current = value;
    }
    return ref.current;
};

export default ({ paymentsInfo, config, esntialDeepLink = {} }) => {
    const {
        paymentOption,
        creditType,
        interestRate,
        loanTerm,
        downPayment,
        downPaymentPercent,
        leaseTerm,
        leaseMileageRange,
        interactions: { hasUpdatedWallet = false, paymentEmphasis = false, hasOpenedWallet = false },
        tradeIn = {},
        zip,
    } = paymentsInfo;

    const isWalletActive = hasUpdatedWallet || paymentEmphasis || hasOpenedWallet;
    const isEsntial = Object.keys(esntialDeepLink).length > 0; // fyc has an eligibility check which is a delayed execution hence we need to update config.
    const { value: tradeInValue = 0, amountOwed = 0 } = tradeIn;

    const stableTradeInValue = useStableValue(tradeInValue);
    const stableAmountOwed = useStableValue(amountOwed);

    const isEcommHyundai = config?.isEcommHyundai || false;

    // Create payments info with stable trade-in values to prevent nulls during state transitions
    const paymentsInfoWithStableTradeIn = useMemo(
        () => ({
            ...paymentsInfo,
            tradeIn: {
                ...tradeIn,
                value: stableTradeInValue,
                amountOwed: stableAmountOwed,
            },
        }),
        [paymentsInfo, tradeIn, stableTradeInValue, stableAmountOwed]
    );

    useEffect(() => {
        if ((isWalletActive || isEsntial) && Object.keys(paymentsInfo).length && Object.keys(config).length) {
            eventBus.emit(UDS_CONFIG_UPDATE_REQUEST, {
                payments: paymentsInfoWithStableTradeIn,
                config: {
                    ...config,
                    ...(isEsntial && { esntialDeepLink }),
                    ...(isEcommHyundai && isEsntial && { hideSendOfferCTA: true, enableLenderDisclaimerCTA: false }),
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentOption,
        creditType,
        interestRate,
        loanTerm,
        downPayment,
        downPaymentPercent,
        leaseTerm,
        leaseMileageRange,
        isWalletActive,
        stableTradeInValue,
        stableAmountOwed,
        zip,
        isEsntial,
        isEcommHyundai,
    ]);

    return null;
};
